import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "bg-white shadow-sm rounded-md divide-y mt-4",
  id: "credit-box"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "lg:flex justify-between items-center py-4 px-6" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h3", { class: "text-2xl leading-8 font-bold text-gray-900" }, "Credit Box and Product Settings"),
    /*#__PURE__*/_createElementVNode("p", { class: "text-sm leading-5 font-normal text-gray-500 mt-1" }, "You’ve got all kinds of products, each with their own credit box. Keep your products and credit boxes up to date so we can be sure to match you with the right deals that match exactly what you’re looking for.")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CreditBoxNavigation = _resolveComponent("CreditBoxNavigation")!
  const _component_CreditBox = _resolveComponent("CreditBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_CreditBoxNavigation, {
      modelValue: _ctx.activeTabIndex,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeTabIndex) = $event)),
      creditBoxes: _ctx.settings.creditBoxes
    }, null, 8, ["modelValue", "creditBoxes"]),
    (_openBlock(), _createBlock(_component_CreditBox, {
      data: _ctx.creditBoxes[_ctx.activeTabIndex]?.value || {},
      name: _ctx.creditBoxes[_ctx.activeTabIndex]?.name || '',
      key: _ctx.activeTabIndex
    }, null, 8, ["data", "name"]))
  ]))
}